export enum EventCategoryEnum {
  ParcoursHabitation = 'Parcours habitation',
  Telechargement = 'Telechargement',
  Formulaire = 'Formulaire',
  InteractionForm = 'Interractions forms',
  Tiroir = 'Tiroirs'
}
